import { render, staticRenderFns } from "./DesktopAccountMenu.vue?vue&type=template&id=e1155aac&scoped=true&"
import script from "./DesktopAccountMenu.vue?vue&type=script&setup=true&lang=js&"
export * from "./DesktopAccountMenu.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DesktopAccountMenu.vue?vue&type=style&index=0&id=e1155aac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1155aac",
  null
  
)

export default component.exports